import { gql } from '@apollo/client';

export const FLUSH_CACHE_MUTATION = gql`
  mutation FlushCache($rebuild: Boolean) {
    flushCache(rebuild: $rebuild)
  }
`;

export const CANCEL_CACHE_REBUILD_MUTATION = gql`
  mutation CancelCacheRebuild {
    cancelCacheRebuild
  }
`;

export const RESET_WIDGET_FORM_STATE_MUTATION = gql`
  mutation ResetWidgetFormState {
    resetWidgetFormState
  }
`;

export const CACHE_STATS_QUERY = gql`
  query CacheStats {
    cacheStats {
      hotelsCached
      hotelsTotal
      hotelsPercentage
      calculatorsCached
      calculatorsTotal
      calculatorsPercentage
      productsCached
      productsTotal
      productsPercentage
      listerStatusCached
      listerStatusTotal
      listerStatusPercentage
      widgetStatusCached
      widgetStatusTotal
      widgetStatusPercentage
      isRebuilding
      preparationPhase
      preparationProgress
      preparationProgressPricing
      preparationProgressProducttext
      preparationProgressPricelist
      hotelsSource
      calculatorsSource
      productsSource
      listerStatusSource
      widgetStatusSource
    }
  }
`;

export const SYSTEM_STATS_QUERY = gql`
  query SystemStats {
    systemStats {
      redis {
        usedMemory
        usedMemoryHuman
        maxMemory
        maxMemoryHuman
        connectedClients
      }
      mysql {
        bufferPoolSize
        bufferPoolSizeHuman
        threadsConnected
        maxConnections
      }
    }
    serviceStats {
      serviceName
      heapUsed
      heapUsedHuman
      heapTotal
      heapTotalHuman
      rss
      rssHuman
      maxOldSpaceSize
      maxOldSpaceSizeHuman
      cpuPercent
      uptime
      uptimeHuman
      online
    }
  }
`;

export const SEED_PRODUCTS_MUTATION = gql`
  mutation SeedProductsAndPricelists($reset: Boolean) {
    seedProductsAndPricelists(reset: $reset)
  }
`;

export const SEED_PRODUCTS_PROGRESS_QUERY = gql`
  query SeedProductsProgress {
    seedProductsProgress {
      isRunning
      progress
      currentSpace
      spacesTotal
      spacesCompleted
      error
      activeSpaces
    }
  }
`;

export const CANCEL_SEED_PRODUCTS_MUTATION = gql`
  mutation CancelSeedProducts {
    cancelSeedProducts
  }
`;

export const SEED_MISSING_TEXTS_MUTATION = gql`
  mutation SeedMissingProductTexts($reset: Boolean) {
    seedMissingProductTexts(reset: $reset)
  }
`;

export const SEED_MISSING_TEXTS_PROGRESS_QUERY = gql`
  query SeedMissingProductTextsProgress {
    seedMissingProductTextsProgress {
      isRunning
      progress
      currentSpace
      spacesTotal
      spacesCompleted
      error
      activeSpaces
    }
  }
`;

export const CANCEL_SEED_MISSING_TEXTS_MUTATION = gql`
  mutation CancelSeedMissingProductTexts {
    cancelSeedMissingProductTexts
  }
`;

export const DEBUG_CACHE_DATA_QUERY = gql`
  query DebugCacheData($hotelId: Int, $refCode: String, $maxBytes: Int) {
    debugCacheData(hotelId: $hotelId, refCode: $refCode, maxBytes: $maxBytes) {
      hotelId
      hotelRefCode
      hotelName
      hotelSpaceId
      hotelDataJson
      pricelistListerRaw
      pricelistWidgetRaw
      listerStatus
      widgetStatus
      foundInCache {
        hotelData
        pricelistLister
        pricelistWidget
        listerStatus
        widgetStatus
      }
      sources {
        name
        key
        type
        source
        inRedis
        redisTtlSeconds
        inDb
        dbUpdatedAt
      }
      meta {
        maxBytes
        hotelDataBytes
        pricelistListerBytes
        pricelistWidgetBytes
        listerStatusBytes
        widgetStatusBytes
        hotelDataTruncated
        pricelistListerTruncated
        pricelistWidgetTruncated
      }
    }
  }
`;

export const DEBUG_REDIS_SCAN_KEYS_QUERY = gql`
  query DebugRedisScanKeys($pattern: String!, $cursor: String, $limit: Int) {
    debugRedisScanKeys(pattern: $pattern, cursor: $cursor, limit: $limit) {
      keys
      cursor
      count
      pattern
    }
  }
`;

export const DEBUG_REDIS_KEY_LOOKUP_QUERY = gql`
  query DebugRedisKeyLookup($key: String!, $maxBytes: Int) {
    debugRedisKeyLookup(key: $key, maxBytes: $maxBytes) {
      key
      exists
      value
      bytes
      ttl
      type
      truncated
      maxBytes
    }
  }
`;

export const ADMIN_GLOBAL_SETTINGS_QUERY = gql`
  query GlobalSettings {
    globalSettings {
      id
      offerSeminargoApprovalEnabled
    }
  }
`;

export const ADMIN_UPDATE_GLOBAL_SETTINGS_MUTATION = gql`
  mutation UpdateGlobalSettings($offerSeminargoApprovalEnabled: Boolean!) {
    updateGlobalSettings(offerSeminargoApprovalEnabled: $offerSeminargoApprovalEnabled) {
      id
      offerSeminargoApprovalEnabled
    }
  }
`;

export const API_AUDIT_LOGS_QUERY = gql`
  query ApiAuditLogs(
    $apiType: String
    $userSearch: String
    $operationName: String
    $success: Boolean
    $serviceName: String
    $from: Date
    $to: Date
    $skip: Int
    $take: Int
  ) {
    apiAuditLogs(
      apiType: $apiType
      userSearch: $userSearch
      operationName: $operationName
      success: $success
      serviceName: $serviceName
      from: $from
      to: $to
      skip: $skip
      take: $take
    ) {
      total
      items {
        id
        createdAt
        apiType
        serviceName
        userId
        userName
        userEmail
        clientId
        clientEmail
        sudoUserId
        sudoUserName
        sudoUserEmail
        operationName
        mutationNames
        httpMethod
        route
        handlerName
        endpoint
        requestId
        ipAddress
        responseStatus
        success
        errorMessage
        jwtClaims
        tokenFingerprint
        releaseVersion
      }
    }
  }
`;
